/**
     * Cart Toggle Section Modes and updates each section 
     */
 function activeProductCartToggleSubscriptionMode() {
    let thisProduct = $(this);

    let amount = thisProduct.attr('data-units'),
        price = 'data-price',
        link = 'data-link',
        ship = 'data-shipping',
        retail = 'data-retail',
        badge;

    let selectedProductAmount = $('.cart--toggle #cartToggle').find(`[data-units='${amount}']`);

    /**
     * Specific vars for Subscription Mode
     */
    let subscriptionMode = {
        wrap: $('.cart--toggle #subscribeSection'),
        prod: $('.cart--toggle #subscribeSection').find(`[data-units='${amount}']`),
        param: $('.cart--toggle #subscribeSection').find('.btn').attr('data-param')
    }

    /**
     * Specific vars for Normal Mode
     */
    let regularMode = {
        wrap: $('.cart--toggle #regularSection'),
        prod: $('.cart--toggle #regularSection').find(`[data-units='${amount}']`),
        param: $('.cart--toggle #regularSection').find('.btn').attr('data-param')
    }

    /**
     * Product buttons states
     */
    $('.cart--toggle .cart__product').removeClass('active');
    selectedProductAmount.addClass('active');

    if (thisProduct.attr('data-badge')) {
        badge = thisProduct.attr('data-badge');
    }

    /**
     * Controls Product Images based on selection
     */
    $('.cart--toggle').removeClass(function (index, className) {
        return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    const carts = [subscriptionMode, regularMode];

    for (const cart of carts) {
        let savingsVal = cart['prod'].attr(retail) - cart['prod'].attr(price);
        let pricePerUnitVal = cart['prod'].attr(price) / amount;

        cart['wrap'].find('.current__value').html(cart['prod'].attr(price));
        cart['wrap'].find('.retail__value').html(cart['prod'].attr(retail));
        cart['wrap'].find('.saving__value').html(parseFloat(savingsVal).toFixed(2));
        cart['wrap'].find('.perUnit__value').html(parseFloat(pricePerUnitVal).toFixed(2));

        cart['wrap'].find('.shipping__value').html(cart['prod'].attr(ship) + ' U.S. SHIPPING');

        cart['wrap'].find('.btn').attr('href', (cart['prod'].attr(link) + cart['param']));
    }

    showProductAndRibbon(amount, badge);
};

/**
 * Subscription Option UI and Behaviour 
 */
$('.cart--toggle .subscribe-wrap__option').on('click', handleSubscribe)

function handleSubscribe() {
    let alternativeContentValue;

    $('.cart--toggle .subscribe-wrap').toggleClass('active');

    if ($('.cart--toggle #cartToggle').attr('data-check') === 'un-subscribe') {
        alternativeContentValue = '';

        $('.cart--toggle #cartToggle').attr('data-check', 'subscribe');

    } else {
        alternativeContentValue = $('.cart--toggle #alternativeContent').attr('data-alt-content');

        $('.cart--toggle #cartToggle').attr('data-check', 'un-subscribe');

    }

    $('.cart--toggle #alternativeContent').html(' ' + alternativeContentValue);

    if ($('#salesBanner').length) {
        let salesBannerHeight = Math.floor($('#salesBanner').height());

        if ($('#salesBanner').hasClass('isSticky')) {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top - salesBannerHeight
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1000);
        }
    } else {
        $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
        }, 1000);
    }

    //- reset subscription disclaimer checkbox
    if ($('.cart--toggle #disclaimerTrigger').hasClass('checked') && !$('.cart--toggle #cartCTASubscribe').hasClass('disabled')) {
        $('.cart--toggle #disclaimerTrigger').removeClass('checked');
        $('.cart--toggle #cartCTASubscribe').addClass('disabled');
        $('.cart--toggle .purchase-box__checkbox').attr('data-checkbox', false);
    }
}

/**
 * Disclaimer Checkbox and Button disabled
 */
$('.cart--toggle #disclaimerTrigger').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('checked') && $('.cart--toggle #cartCTASubscribe').hasClass('disabled')) {
        $(this).addClass('checked');
        $('.cart--toggle #cartCTASubscribe').removeClass('disabled');
        $('.cart--toggle .purchase-box__checkbox').attr('data-checkbox', true);

    } else {
        $(this).removeClass('checked');
        $('.cart--toggle #cartCTASubscribe').addClass('disabled');
        $('.cart--toggle .purchase-box__checkbox').attr('data-checkbox', false);
    }
});

$('.cart--toggle .cart__product').on('click', activeProductCartToggleSubscriptionMode);
$('.cart--toggle .cart__product.active').trigger("click");